module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.categories), function(category) {
    return _c('div', {
      staticClass: "col s4"
    }, [_c('div', {
      staticClass: "card darken-1",
      class: [(_vm.selectedMetricCategory !== null && category.id == _vm.selectedMetricCategory.id) ? _vm.blueCard : _vm.greyCard]
    }, [_c('div', {
      staticClass: "card-content white-text"
    }, [_c('span', {
      staticClass: "card-title center-align"
    }, [_vm._v(_vm._s(category.display))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (category.showDetails),
        expression: "category.showDetails"
      }]
    }, [_vm._v(_vm._s(category.description))])]), _vm._v(" "), _c('div', {
      staticClass: "card-action center-align"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.categoryDetailsClick(category)
        }
      }
    }, [(!category.showDetails) ? _c('span', [_vm._v("Show Details")]) : _c('span', [_vm._v("Hide Details")])]), _vm._v(" "), _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.selectCategory(category)
        }
      }
    }, [_vm._v("Select")])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dfbc2af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetricSelector.vue
// module id = 144
// module chunks = 1